import { Page } from '@/core/architecture'

import { ArtistMissionsTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ArtistMissions Page
 * Implemented as a practical sample.
 */
export const ArtistMissions: Page = () => {
  const { state, actions } = useViewModel()

  return <ArtistMissionsTemplate state={state} {...actions} />
}
